import ttf from './OpenDyslexic-Regular.ttf';
import woff from './OpenDyslexic-Regular.woff';
import woff2 from './OpenDyslexic-Regular.woff2';

export default {
  name: 'Open Dyslexic',
  variant: 'Regular',
  ttfUrl: ttf,
  woffUrl: woff,
  woff2Url: woff2,
} as const;
